module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71836/img/content-remix-post-publish/content-remix-fr.png"